import { render } from "./hotSelect.vue?vue&type=template&id=58ace027&scoped=true&ts=true"
import script from "./hotSelect.vue?vue&type=script&lang=ts"
export * from "./hotSelect.vue?vue&type=script&lang=ts"

import "./hotSelect.vue?vue&type=style&index=0&id=58ace027&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ace027"]])

export default __exports__